import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturWeitra() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-weitra-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-weitra-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="weitra" />
      </div>
    </div>
  );
}

export default BodentemperaturWeitra;
